<template lang="pug">

.base-bloco-totalizador
    .container-card
        .container-img
            img(:src='buscarUrlImagem(icone)')
        .container-body
            .container-titulo
                span.base-bloco-totalizador-titulo {{ etapa }}
                span.base-bloco-totalizador__interno-numero {{formatNumber(numero)}}

            .base-bloco-totalizador__interno
                span.base-bloco-totalizador__interno-texto Área: {{formatNumber(hectares)}} ha
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'BaseCardTotalizadorRastreabilidade',
    props: {
        etapa: {
            type: String,
            default: () => ''
        },
        texto: {
            type: String,
            default: () => ''
        },
        numero: {
            type: String,
            default: () => ''
        },
        hectares: {
            type: String,
            default: () => ''
        },
        icone: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    },
    methods: {
        buscarUrlImagem(nome) {
            return require(`@/assets/raizen-icons/rastreabilidade/${nome}.png`);
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        }
    }
};
</script>

<style lang="scss" scoped>

.container-card {
    display: flex;
    gap: 27px;
}

.container-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5px;
}

.container-img {
    align-self: center;
}
 
.base-bloco-totalizador {
    background: var(--white);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 89px;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    gap: 3px;

    .base-bloco-totalizador-titulo {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color:#3B3B3B;
    }
    .base-bloco-totalizador__interno {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 40px;

        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 25px !important;
            background-color: var(--primary) !important;
        }
        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
    }
    .base-bloco-totalizador__interno-numero {
        flex-wrap: wrap;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #00413C;
    }
    .container-titulo {
        width: 100%;
        display: grid;
        grid-template-columns: 90% 10%;
    }

    span {
        padding: 3px;
        &.base-bloco-totalizador__interno-texto {
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #3B3B3B;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
@media only screen and (max-width: 1334px) {
    .base-bloco-totalizador {
        min-width: 48% !important;
    }
}
</style>
